import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { RepresentativeRepositoryInterface } from '../../domain/representative/interfaces/repositories/representative.repository.interface';
import { Types } from '../../domain/types.domain';
import {
  ValidateRfInput,
  ValidateRfOutput,
  UploadDocumentInput,
  UploadDocumentOutput,
  RegisterRepresentativesInput,
  RegisterRepresentativesOutput,
} from '../../domain/representative/dtos/representative.dto';

@Injectable()
export class RepresentativeHttpRepository
  implements RepresentativeRepositoryInterface
{
  private readonly _http = inject(HttpClient);
  private readonly _settings = inject(Types.Settings);

  async validateRf(input: ValidateRfInput): Promise<ValidateRfOutput> {
    return lastValueFrom(
      this._http.post<ValidateRfOutput>(
        `${this._settings.usersUrl.v2}/representatives/validate-rf`,
        input
      )
    );
  }

  async uploadDocument(input: UploadDocumentInput): Promise<UploadDocumentOutput> {
    // 1. Get signed URL from backend
    const { uploadUrl, documentUrl } = await lastValueFrom(
      this._http.post<{ uploadUrl: string; documentUrl: string }>(
        `${this._settings.usersUrl.v2}/representatives/upload-document`,
        { cnpj: input.cnpj, cpf: input.cpf }
      )
    );

    // 2. Upload file directly to S3 via signed URL
    await lastValueFrom(
      this._http.put(uploadUrl, input.file, {
        headers: { 'Content-Type': '' },
      })
    );

    return { documentUrl };
  }

  async registerRepresentatives(
    input: RegisterRepresentativesInput
  ): Promise<RegisterRepresentativesOutput> {
    return lastValueFrom(
      this._http.post<RegisterRepresentativesOutput>(
        `${this._settings.usersUrl.v2}/company/register-representatives`,
        input
      )
    );
  }
}
